export default __webpack_public_path__ + "static/rsz_psrp-eb439f3f7e915a552df80aa03d3e6cea.png";